export default "__VITE_ASSET__10df30a3__"